/**
 * The lead form widget, embedded verbatim.
 *
 * This is the single definition used by BOTH the hero and the "Get Free
 * Estimate" popup, so the two are guaranteed identical — same markup, same
 * attributes, same natural dimensions. Do not restyle, resize, or wrap this
 * in a scrolling container.
 *
 * The height below is the widget's own declared `data-height`, not a
 * constraint we are imposing. form_embed.js (loaded once in index.html)
 * grows the frame from there as the form's content requires. There is no
 * min-height, max-height, or overflow rule anywhere in this path.
 */

export const FORM_ID = "vjCmW0LaYtkm8SMK1Zq7";
export const FORM_IFRAME_ID = `inline-${FORM_ID}`;
const FORM_SRC = `https://link.systemic-digital.net/widget/form/${FORM_ID}`;
const NATURAL_HEIGHT = 670;

interface Props {
  className?: string;
}

const LeadFormEmbed = ({ className = "" }: Props) => (
  <div className={`widget-embed ${className}`}>
    <iframe
      src={FORM_SRC}
      id={FORM_IFRAME_ID}
      data-layout="{'id':'INLINE'}"
      data-trigger-type="alwaysShow"
      data-trigger-value=""
      data-activation-type="alwaysActivated"
      data-activation-value=""
      data-deactivation-type="neverDeactivate"
      data-deactivation-value=""
      data-form-name="Website Form"
      data-height={NATURAL_HEIGHT}
      data-layout-iframe-id={FORM_IFRAME_ID}
      data-form-id={FORM_ID}
      title="Website Form"
      loading="lazy"
      scrolling="no"
      style={{
        width: "100%",
        height: NATURAL_HEIGHT,
        border: "none",
        borderRadius: "10px",
        display: "block",
      }}
    />
  </div>
);

export default LeadFormEmbed;
